import { FAQS } from "@/data/property";
import { MaskLineInView } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#FAFAF8] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-3 gap-12">
        <div className="lg:sticky lg:top-28 h-fit">
          <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">FAQ</span>
          <h2 className="mt-3 font-display font-semibold text-[#0E2A47] text-4xl md:text-5xl tracking-tight leading-none">
            <MaskLineInView>Before you</MaskLineInView>
            <MaskLineInView delay={0.1}>
              <span className="font-serif-accent italic font-normal text-[#1FB6C9]">book.</span>
            </MaskLineInView>
          </h2>
          <p className="mt-6 text-[#0E2A47]/70 font-body">
            Still curious? Message us directly on Airbnb — we usually reply within the hour.
          </p>
        </div>

        <div className="lg:col-span-2">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#0E2A47]/10"
              >
                <AccordionTrigger className="text-left font-display font-medium text-lg text-[#0E2A47] hover:text-[#1FB6C9] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#0E2A47]/70 font-body text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
